import styled, {
  FlattenSimpleInterpolation,
  css,
} from "styled-components/macro";
import {
  darkModeCardBackgroundColor,
  darkModeTextColor,
  highlight,
} from "../../../../../constants/colors";
import { animated } from "@react-spring/web";
import {
  ControlsAnchor,
  DEBUGGER_HEADER_HEIGHT,
  DEBUGGER_MEDIA_QUERY,
  DEBUGGER_PADDING,
} from "./debuggerUtils";
import { Z_INDEX } from "constants/constants";

export const FlightDebuggerStyles = styled.div<{ $width: number }>`
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${Z_INDEX.L12};
  box-sizing: border-box;
  opacity: 0.9;
  width: ${props => props.$width}px;
  min-width: 360px;
  max-width: 100vw;
  max-height: fit-content;
  box-sizing: border-box;
  height: fit-content;
  border-radius: 8px;
  font-size: 1em;
  line-height: 1em;
  .btnClose {
    color: white;
  }
  .lightText {
    color: hsl(0, 0%, 60%);
  }
  .darkText {
    color: black;
  }
  .warning {
    color: ${highlight};
  }
  h1.title {
    font-size: 1em;
    text-shadow: 1px 1px 2px #00000040;
    margin: 0 auto 1em auto;
    width: fit-content;
  }
  .titleRow {
    padding-right: 1em;
  }
  .togglesRow {
    width: 360px;
    height: 44px;
    display: grid;
    align-items: center;
    grid-auto-flow: column;
    .MuiFormControlLabel-label,
    label {
      font-size: 0.75rem;
      width: fit-content;
    }
  }
  .gridRows {
    display: grid;
    grid-gap: 0.5em;
  }
  .gridColumns {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 0.5em;
  }
  .btnClose {
    position: absolute;
    top: 0;
    right: 0;
  }
  .networkItemsContainer {
    overflow-x: visible;
    margin-left: -10px;
    padding-left: 10px;
    display: grid;
    padding-bottom: 0.5em;
    width: 100%;
  }
  .networkItemRow {
    padding: 5px 32px;
    margin: 0 -32px;
    position: relative;
    &:hover {
      font-weight: bold;
      background: rgb(243, 243, 243);
      .networkStatus {
        border: 1px solid black;
        margin: -1px;
      }
      .MuiIconButton-root {
        color: black;
      }
    }
    &.selected {
      background: rgb(229, 229, 229);
      font-weight: bold;
    }
    &.profile {
      padding: 16px 32px;
      margin: -16px -32px;
    }
    cursor: pointer;
    align-items: center;
    justify-items: left;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 1em;
  }

  .btnInspectWrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    display: grid;
    place-items: center;
  }

  .networkStatus {
    position: relative;
    .awaitingDataIndicator {
      position: absolute;
      inset: 0;
    }
    border-radius: 9999px;
    width: 16px;
    height: 16px;
    transform: translateY(3px);
    &.notConnected {
      background: tomato;
      box-shadow: 0 0 8px 1px tomato;
    }
    &.connected {
      background: limegreen;
      box-shadow: 0 0 8px 1px limegreen;
    }
    &.notRequired {
      background: lightgrey;
      box-shadow: 0 0 8px 1px lightgrey;
      &.connected {
        background: khaki;
        box-shadow: 0 0 8px 1px khaki;
      }
    }
  }

  .networkNameContainer {
    display: grid;
    grid-gap: 0.25em;
    grid-template-rows: 1fr auto;
    width: 100%;
    align-items: center;
    position: relative;
    .itemCountsContainer {
      font-size: 0.75em;
      display: flex;
      line-height: 1em;
      flex-wrap: wrap;
      .itemCount:not(:last-child) {
        margin-right: 1.5ch;
      }
    }
  }
  .networkName {
    font-size: 13px;
  }

  .controls-section {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: auto 1fr;
    height: 24px;
    align-items: center;
    margin: -10px 16px -10px auto;
    h1 {
      font-size: 0.7em;
      margin: 0;
      width: 5em;
      line-height: 1em;
    }
  }
  button {
    text-transform: none;
    padding: 2px 0;
  }
  .control-buttons-section {
    padding-left: 1em;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1em;
    button {
      padding: 0.2em;
      text-transform: none;
      line-height: 1.3em;
    }
  }
  .serverTitle {
    font-weight: bold;
    padding-top: 1em;
    font-size: 1em;
  }
  .serverSection {
    display: grid;
    grid-gap: 0.15em;
  }
`;

export const Header = styled(animated.div)<{
  $collapsed?: boolean;
  $customCss?: string | FlattenSimpleInterpolation;
}>`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 16px;
  padding-right: 16px;
  height: ${DEBUGGER_HEADER_HEIGHT}px;
  font-family: sans-serif;
  font-size: 14px;
  color: #fff;
  cursor: move;
  cursor: grab;
  /* disabling user selection inorder to avoid unnecessary text selection or drags */
  user-select: none;
  background-color: #000;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: ${props => (props.$collapsed ? 8 : 0)}px;
  border-bottom-right-radius: ${props => (props.$collapsed ? 8 : 0)}px;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.14);
  ${DEBUGGER_MEDIA_QUERY} {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
`;

export const CollapseIcon = styled.div<{ $collapsed: boolean }>`
  width: 30px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  cursor: pointer;
  &:after {
    content: "";
    display: block;
    height: 3px;
    width: 16px;
    background-color: white;
  }
  &:before {
    content: "";
    display: ${props => (props.$collapsed ? "block" : "none")};
    height: 16px;
    width: 3px;
    transform: translateX(9.5px);
    background-color: white;
  }
`;

interface FloatProps {
  "data-width": number;
  "data-anchor": ControlsAnchor | string;
  $isTouchDevice: boolean;
  $isDarkMode: boolean;
}
export const AnimatedFloatStyles = styled(animated.div)<FloatProps>`
  pointer-events: auto;
  overflow: hidden;
  box-shadow: 0px 4px 10px 2px #0000004f;
  display: flex;
  z-index: ${Z_INDEX.L12};
  flex-direction: column;
  top: ${posProps([ControlsAnchor.TOP_LEFT, ControlsAnchor.TOP_RIGHT])};
  right: ${posProps([ControlsAnchor.BOTTOM_RIGHT, ControlsAnchor.TOP_RIGHT])};
  bottom: ${posProps([
    ControlsAnchor.BOTTOM_RIGHT,
    ControlsAnchor.BOTTOM_LEFT,
  ])};
  left: ${posProps([ControlsAnchor.TOP_LEFT, ControlsAnchor.BOTTOM_LEFT])};
  width: ${props => props["data-width"]}px;
  border-radius: 16px;
  background-color: none;
  border-radius: 8px;
  /* for touch devices with small widths, attach to & pop up from the bottom */
  @media screen and (max-width: 600px) {
    ${props =>
      props.$isTouchDevice
        ? css`
            transform: translateY(-${DEBUGGER_PADDING.y / 2}px) !important;
            flex-direction: column-reverse;
            top: auto;
            bottom: -${DEBUGGER_PADDING.y / 2}px;
            left: 0;
          `
        : ""}
  }
  /* for small mobile devices, stretch to full width */
  ${DEBUGGER_MEDIA_QUERY} {
    right: 0;
    width: auto;
  }
  .dragArea {
    width: 100%;
    height: 100%;
    margin-left: -90px;
    padding-left: 90px;
    display: grid;
    place-items: center left;
  }
  .MuiSvgIcon-root {
    z-index: ${Z_INDEX.L1};
    cursor: pointer;
  }
  ${({ $isDarkMode }) =>
    $isDarkMode
      ? css`
          background: ${darkModeCardBackgroundColor};
          color: ${darkModeTextColor};
        `
      : ""}
`;

function posProps(positions: ControlsAnchor[]) {
  return function posPropsFn(props: any) {
    return positions.includes(props["data-anchor"]) ? "16px" : "auto";
  };
}
